/**
 * @description 对于不同支付方式处理
 */
import config from '../config/'
import {clientService} from '../services/clientService'
import { Base64 } from 'js-base64'
import { getSessionCache } from '../utils'

export const PayHelpers = {
  // 微信公众号支付
  _PUBLIC: (data) => {
    if (data.datas.payStr) {
      window.location.href = data.datas.payStr
    }
  },
  // SDK支付
  _SDK: (data) => {
    if (config.env === 'app' && config.payType === 'SDK') {
      if (getSessionCache('payType') === 'hbPay') { // 花呗支付截取
        const hbPayStr = data.datas.payStr
        data.datas.payStr = Base64.encode(hbPayStr)
      }
      clientService.pay(data.datas, (data) => {
        if (data.result === 'SUCCESS') {
          window.location.href = '#/result?state=success'
        } else {
          window.location.href = '#/detail'
        }
      })
    }
  },
  // H5支付
  _H5: (data, context) => {
    if (data.datas.payStr) {
      if (data.datas.payMethodCode === 'WXPAY' && config.env != 'app') {
        // 微信H5自有渠道
        context.wechatPay.payUrl = data.datas.payStr
        context.wechatPay.orderId = data.datas.orderId
        // 显示微信弹窗
        context.wechatPay.showModal = true
        // 跳转微信APP
        context.wechatPay.toggleWxApp = true
      } else {
        // 支付宝h5或其他h5渠道
        window.location.href = data.datas.payStr
      }
    }
  },
  // 决定支付环境
  determinEnv: () => {
    // 微信环境
    let Env = '_H5'
    if (/micromessenger/.test(navigator.userAgent.toLowerCase())) {
      Env = '_PUBLIC'
    } else if (config.env === 'app' && config.payType === 'SDK') {
      Env = '_SDK'
    }
    return Env
  },
  // 辅助函数 获取支付环境及子支付payMethodSubCode
  determinPaySubCode: (payment, Env) => {
    let payMethodSubCode = ''
    if (payment.paySubMethodList && payment.paySubMethodList.length) {
      const payType = getSessionCache('payType')
      // 处理花呗支付
      if (payType === 'hbPay') {
        payMethodSubCode = Env === '_SDK' ? config.huabeiPaySubCodeSDK : config.huabeiPaySubCodeH5
      } else if (payment.paymentMethodId.indexOf('SCAN') !== -1) { // 优先处理扫码支付 paySubMethodList只有一个
        payMethodSubCode = payment.paySubMethodList[0].paymentSubMethodId
      } else if (payment.paymentMethodId.indexOf('CBCPAY') !== -1) {
        // 建行龙支付
        payMethodSubCode = config.cbcPaySubCode || payment.paySubMethodList[0].paymentSubMethodId
      } else if (payment.paymentMethodId.indexOf('ABC_WALLET_PAY') !== -1) {
        payMethodSubCode = payment.paySubMethodList[0].paymentSubMethodId
      } else if (payment.paymentMethodId.indexOf('SPDB_WALLET') !== -1) {
        // 浦发
        payMethodSubCode = payment.paySubMethodList[0].paymentSubMethodId
      } else if (payment.paymentMethodId.indexOf('HEBAO_PAY') !== -1) {
        // 和包支付
        payMethodSubCode = payment.paySubMethodList[0].paymentSubMethodId
      } else if (payment.paymentMethodId.indexOf('DIGITAL_RMB') !== -1) {
        // 数字人民币
        payMethodSubCode = payment.paySubMethodList[0].paymentSubMethodId
      } else if (payment.paymentMethodId.indexOf('CITIC_WALLET') !== -1) {
        // 中信钱包
        payMethodSubCode = payment.paySubMethodList[0].paymentSubMethodId
      } else {
        // 除扫码支付外，其他支付方式paySubMethodList字段都会返回 H5、SDK(公众号支付)方式
        let subPayment = payment.paySubMethodList.filter((subPayment) => subPayment.paymentSubMethodId === payment.paymentMethodId + Env)[0]
        if (subPayment) {
          payMethodSubCode = subPayment.paymentSubMethodId
        } else {
          let subPayment = payment.paySubMethodList.filter((subPayment) => subPayment.paymentSubMethodId.includes(Env))[0]
          if (subPayment) {
            payMethodSubCode = subPayment.paymentSubMethodId
          } else {
            payMethodSubCode = payment.paySubMethodList[0].paymentSubMethodId
          }
        }
      }
    }
    return payMethodSubCode
  }
}
